import { KTCard, initialQueryState } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
import { roleColumns } from './_columns'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useAuth } from '../../../../auth'
import {
  QueryRequestProvider,
  useQueryRequest,
} from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { getUserById } from '../../../data-administration/data-admininstration-list/core/_requests'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import {
  ListViewProvider,
  useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'

const DropOffPointList = () => {
  const { auth } = useAuth()
  const hideDropdown = auth?.data?.userType === 'SMART_CENTRE' || false
  const { data } = useQuery(
    `users?page=0&size=10&type=FRANCHISE`,
    () => getUserById('', 'users?page=0&size=10&type=FRANCHISE'),
    {
      enabled: hideDropdown,
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )
  const { updateState } = useQueryRequest()
  const [categoriesList, setCategoriesList] = useState([{ label: 'Select one', value: '' }])
  useEffect(() => {
    if (data && data.length) {
      let dropdownData: any = [{ label: 'Select one', value: '' }]
      data.map((eachData) => {
        return dropdownData.push({ label: eachData?.personalDetails?.name, value: eachData.id })
      })
      setCategoriesList(dropdownData)
      updateState({
        enabled: true,
        initialApi: `categories/${dropdownData[0].value}/items`,
        ...initialQueryState,
      })
    }
  }, [data])
  const statusLis = [
    { label: 'Select one', value: '' },
    /* {label: 'CREATED', value: 'CREATED'},
    {label: 'ACCEPTED', value: 'ACCEPTED'},
    {label: 'REJECTED', value: 'REJECTED'},
    {label: 'COMPLETED', value: 'COMPLETED'}, */
    { label: 'In transit', value: 'CREATED' },
    { label: 'Delivered', value: 'COMPLETED' },
  ]
  const searchElements = [
    {
      type: 'select',
      value: 'select',
      options: statusLis,
      name: 'status',
      label: 'Status',
    },
    {
      type: 'datePicker',
      name: 'start_date',
      label: 'Start date',
    },
    {
      type: 'datePicker',
      name: 'end_date',
      label: 'End date',
    },
    {
      ...(hideDropdown && {
        type: 'select',
        value: 'select',
        options: categoriesList,
        name: 'franchise',
        label: 'Franchise',
      }),
    },
  ]
  const { itemIdForUpdate } = useListView()
  return (
    <KTCard>
      <UsersListHeader
        showDownload
        showResetButton={true}
        searchElements={searchElements}
        placeholder='Search Category'
        initialApi='convert/orders'
      />
      <UsersTable initialApi='convert/orders' columnProps={roleColumns} />
      <UserEditModal
        showViewPage={itemIdForUpdate?.showCertificate ? true : false}
        getByIdApi='convert/orders/'
        formName='ExternalSaleModalForm'
      />
    </KTCard>
  )
}
const SubCategoryWrapper = () => (
  <QueryRequestProvider initialValue={{ initialApi: 'convert/orders', size: "50" }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <DropOffPointList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { SubCategoryWrapper }
